import React from "react";

interface Props {
  videos: any[];
}

const ChannelHealth: React.FC<Props> = ({ videos }) => {
  // Simple heuristic: missing description or short title
  const issues = videos.filter(v => !v.description || v.title.length < 10);
  const healthScore = videos.length > 0 ? Math.max(0, 100 - (issues.length / videos.length) * 100) : 100;

  return (
    <div style={{ background: "#fff", borderRadius: "16px", padding: "24px", boxShadow: "0 10px 30px rgba(0,0,0,0.05)" }}>
      <h3 style={{ margin: "0 0 20px 0", color: "#111827" }}>Channel Health Audit</h3>

      <div style={{ display: "flex", alignItems: "center", gap: "20px", marginBottom: "30px" }}>
        <div style={{
          width: "80px",
          height: "80px",
          borderRadius: "50%",
          background: `conic-gradient(#10b981 ${healthScore}%, #f3f4f6 0)`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative"
        }}>
          <div style={{
            width: "65px",
            height: "65px",
            borderRadius: "50%",
            background: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "20px",
            fontWeight: 700,
            color: healthScore > 80 ? "#10b981" : "#f59e0b"
          }}>
            {Math.round(healthScore)}%
          </div>
        </div>
        <div>
          <p style={{ margin: 0, fontWeight: 600, fontSize: "16px" }}>Channel Optimization Score</p>
          <p style={{ margin: 0, fontSize: "14px", color: "#6b7280" }}>
            {healthScore === 100 ? "Perfect standing!" : `${issues.length} critical issues detected.`}
          </p>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <div style={{ background: "#fdf2f2", padding: "12px", borderRadius: "8px", border: "1px solid #fee2e2" }}>
          <p style={{ margin: 0, fontSize: "13px", color: "#991b1b", fontWeight: 600 }}>Broken Link Detection</p>
          <p style={{ margin: "4px 0 0", fontSize: "12px", color: "#b91c1c" }}>No broken links found in your recent metadata.</p>
        </div>

        <div style={{ background: "#eff6ff", padding: "12px", borderRadius: "8px", border: "1px solid #dbeafe" }}>
          <p style={{ margin: 0, fontSize: "13px", color: "#1e40af", fontWeight: 600 }}>SEO Completeness</p>
          <p style={{ margin: "4px 0 0", fontSize: "12px", color: "#1d4ed8" }}>
            {issues.length > 0 ? `${issues.length} videos have incomplete descriptions.` : "All videos meet SEO density standards."}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ChannelHealth;
